import { render, staticRenderFns } from "./BrevoNewsletterBox.vue?vue&type=template&id=73bc3b2c&scoped=true&"
import script from "./BrevoNewsletterBox.vue?vue&type=script&lang=js&"
export * from "./BrevoNewsletterBox.vue?vue&type=script&lang=js&"
import style0 from "./BrevoNewsletterBox.vue?vue&type=style&index=0&id=73bc3b2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc3b2c",
  null
  
)

export default component.exports